<template>
  <div class="d-flex p-3 justify-content-between align-items-center"
    :class="{ 'notification text-contrast': displayNotification, 'bg-blur-darker text-white': !displayNotification }">
    <transition>
      <div class="d-flex align-items-center" v-if="displayNotification">
        <button class="btn text-contrast" type="button" @click="presentationStore.setVisibleTab('Presentation')">
          <AVIcon icon="arrow-alt-circle-left" />
        </button>
        <span class="lead text-truncate">{{ $t(notification) }}</span>
      </div>
      <h5 v-else class="mb-0">{{ header }}</h5>
    </transition>
    <button class="btn btn-toned text-light d-sm-none" :aria-label="$t('js.actions.open_menu')" :class="{ 'text-contrast': displayNotification }"
      type="button" @click.prevent="$parent.$emit('showNav')">
      <AVIcon icon="bars" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from "vue";
import breakpoint from "@/entrypoints/shared/breakpoint";
import { usePresentationStore } from "@/entrypoints/stores/presentation";

const presentationStore = usePresentationStore();

defineProps({
  header: {
    type: String,
    default: "",
  },
});

const notification = ref(null);

const fullscreen = computed(() => breakpoint.less("sm"));

const ballotState = computed(() => presentationStore.activeSlide ? presentationStore.activeSlide.state || null : null);

const displayNotification = computed(() => fullscreen.value && notification.value);

watch(() => presentationStore.activeSlide, (newSlide, oldSlide) => {
  if (oldSlide !== undefined) {
    if (newSlide !== oldSlide) notification.value = "js.sidebar.notifications.active_slide_changed";
  }
});

watch(ballotState, (newState, oldState) => {
  if (oldState !== null)
    switch (newState) {
      case "open":
        notification.value = "js.sidebar.notifications.ballot_has_opened";
        break;
      case "countdown":
        notification.value = "js.sidebar.notifications.ballot_will_close";
        break;
      case "closed":
      case "new":
        notification.value = "js.sidebar.notifications.ballot_has_closed";
        break;
      case "finished":
        notification.value = "js.sidebar.notifications.ballot_has_finished";
        break;
    }
});
</script>